import { render, staticRenderFns } from "./SysBigdataList.vue?vue&type=template&id=4fa82afa&scoped=true&"
import script from "./SysBigdataList.vue?vue&type=script&lang=js&"
export * from "./SysBigdataList.vue?vue&type=script&lang=js&"
import style0 from "./SysBigdataList.vue?vue&type=style&index=0&id=4fa82afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa82afa",
  null
  
)

export default component.exports